import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'user-instruction',
    templateUrl: './user-instruction.component.html',
    styleUrls: ['./user-instruction.component.scss'],
    standalone: false
})
export class UserInstructionComponent {
  @Input() tenantId!: string;
  @Input() loading = true;

  @Output() cancelProcess = new EventEmitter<void>();
  @Output() confirmedProcess = new EventEmitter<void>();

  onCancel(): void {
    this.cancelProcess.emit();
  }

  onContinue(): void {
    this.confirmedProcess.emit();
  }
}
